import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { padWithZeros, sortFloors } from '../../helpers';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../partials/custom_date_picker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ReportTabs from './report_tabs';

const KpiCard = ({ label, value, icon, color = '#00C6FE', sub }) => (
    <div className="bg-gray-2 p-3 d-flex flex-column" style={{ borderRadius: 8, minWidth: 140, borderLeft: `3px solid ${color}` }}>
        <div className="d-flex align-items-center justify-content-between mb-1">
            <span className="gray font-10 poppins">{label}</span>
            {icon && <i className={`${icon} font-12`} style={{ color }} />}
        </div>
        <span className="white poppins toBold" style={{ fontSize: '1.7rem', lineHeight: 1 }}>{value}</span>
        {sub && <span className="font-10 mt-1 poppins" style={{ color }}>{sub}</span>}
    </div>
);

class Occupation extends React.Component {
    state = {
        menu_toggled: false,
        floors: [],
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        filters: {
            CheckIn: moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD').utc(),
            CheckOut: moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD').add(1, 'days').utc(),
            IdRoom: null,
            IdFloor: null,
            IdStatus: null,
        },
        search: '',
        pickRoom: false,
        pickFloor: false,
        pickStatus: false,
    }

    componentWillMount() {
        this.props.logic_actions?.fetch_conversion_rates();
        const { params } = this.props;
        let user = fakeAuth.getUser();
        if (user.Permissions & (config.permissions.SuperAdmin | config.permissions.Reports) === 0) {
            this.props.router.goBack();
        } else {
            this.props.properties_actions && this.props.properties_actions.fetch_one(params.id);
            this.props.floors_actions && this.props.floors_actions.fetch(params.id);
            this.props.rooms_actions && this.props.rooms_actions.fetch(params.id);
            this.onFetch();
        }
    }

    componentWillReceiveProps = nextProps => {
        const { floors = [], bookings, rooms } = nextProps;
        if (!rooms) return;

        let all_booked_rooms = _.chain(bookings).each(b => {
            b.Rooms.forEach(room => _.extend(room, _.pick(b, 'PNR', 'GivenName', 'Guests', 'Accounting', 'IdStatus')));
        }).map(b => b.Rooms).flatten().compact().value();

        let resources = [];
        sortFloors(floors).forEach(floor => {
            _.sortBy(floor.Pieces, 'Label').forEach(piece => {
                resources.push({
                    id: piece.IdPiece,
                    floor: floor.Label,
                    IdFloor: floor.IdFloor,
                    title: piece.Label,
                    name: (_.find(rooms, r => r.IdRoom === piece.IdRoom) || {}).GivenName,
                    IdRoom: (_.find(rooms, r => r.IdRoom === piece.IdRoom) || {}).IdRoom,
                    BOOK: _.find(all_booked_rooms, br => br.IdPiece === piece.IdPiece),
                });
            });
        });

        rooms.forEach(r => { r.TOTAL = _.filter(resources, x => x.IdRoom === r.IdRoom).length; });

        const allFloors = sortFloors(_.uniqBy(
            resources.map(r => ({ IdFloor: r.IdFloor, Label: r.floor })),
            'IdFloor'
        ));

        this.setState({
            floors: allFloors,
            bookings,
            all_booked_rooms,
            resources,
            rooms: [{ GivenName: 'Todas', TOTAL: resources.length, IdRoom: null }, ...rooms],
            bootstrapped: !!bookings,
        });
    }

    onFetch = () => {
        this.props.booking_actions && this.props.booking_actions.fetch_range({
            IdProperty: this.props.params.id,
            CheckIn: moment(this.state.filters.CheckIn).format('YYYY-MM-DD'),
            CheckOut: moment(this.state.filters.CheckOut).format('YYYY-MM-DD'),
        });
    }

    getFiltered = () => {
        const { resources, filters, search } = this.state;
        if (!resources) return [];
        return _.chain(resources)
            .filter(r => r.BOOK)
            .filter(r => filters.IdRoom ? r.IdRoom === filters.IdRoom : true)
            .filter(r => filters.IdFloor ? r.IdFloor === filters.IdFloor : true)
            .filter(r => filters.IdStatus ? parseInt(r.BOOK.IdStatus, 10) === filters.IdStatus : true)
            .filter(r => {
                if (!search) return true;
                return JSON.stringify(r).toLowerCase().includes(search.toLowerCase());
            })
            .value();
    }

    renderHeader = () => (
        <div className="d-flex">
            <div className="w-100 d-flex">
                <i className="icon-lb_reportes blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Reportes</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    )

    renderKpis = () => {
        const { resources } = this.state;
        if (!resources) return null;
        const total = resources.length;
        const occupied = resources.filter(r => r.BOOK).length;
        const available = total - occupied;
        const pct = total > 0 ? Math.round(occupied * 100 / total) : 0;

        return (
            <div className="d-flex flex-wrap mt-3 mb-2" style={{ gap: 10 }}>
                <KpiCard label="Total hab." value={total} icon="fas fa-door-open" color="#00C6FE" />
                <KpiCard label="Ocupadas" value={occupied} icon="fas fa-bed" color="#6E44FF" />
                <KpiCard label="Disponibles" value={available} icon="fas fa-check-circle" color="#00c97a" />
                <KpiCard label="% Ocupación" value={`${pct}%`} icon="fas fa-percent" color={pct >= 80 ? '#00c97a' : pct >= 50 ? '#FFC107' : '#FF6B6B'} sub={`de ${total} habitaciones`} />
            </div>
        );
    }

    renderFilters = () => {
        const { filters, rooms = [], floors = [] } = this.state;
        const selectedRoom = _.find(rooms, r => r.IdRoom === filters.IdRoom) || rooms[0] || {};
        const selectedFloor = _.find(floors, f => f.IdFloor === filters.IdFloor);
        const selectedStatus = _.find(config.booking_status, s => s.id === filters.IdStatus);

        return (
            <Animated animationIn="fadeInDown" animationInDuration={200} className="d-flex flex-wrap align-items-flex-end mt-3 mb-2" style={{ gap: 10 }}>

                {/* CheckIn */}
                <div style={{ minWidth: 140 }}>
                    <label className="white poppins font-11 d-block mb-1">Entrada</label>
                    <DatePicker
                        selected={filters.CheckIn}
                        customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Desde" />}
                        showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                        maxDate={filters.CheckOut}
                        onChange={date => {
                            const { filters } = this.state;
                            filters.CheckIn = moment(date).utc();
                            this.setState({ filters });
                        }}
                    />
                </div>

                {/* CheckOut */}
                <div style={{ minWidth: 140 }}>
                    <label className="white poppins font-11 d-block mb-1">Salida</label>
                    <DatePicker
                        selected={filters.CheckOut}
                        customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Hasta" clear={() => {
                            const { filters } = this.state;
                            filters.CheckOut = null;
                            this.setState({ filters });
                        }} />}
                        showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                        minDate={filters.CheckIn}
                        onChange={date => {
                            const { filters } = this.state;
                            filters.CheckOut = moment(date).utc();
                            this.setState({ filters });
                        }}
                    />
                </div>

                {/* Room type */}
                {rooms.length > 0 && (
                    <div style={{ minWidth: 170 }}>
                        <label className="white poppins font-11 d-block mb-1">Tipo de hab.</label>
                        <div className="black-input d-flex">
                            <Dropdown isOpen={this.state.pickRoom} toggle={() => this.setState({ pickRoom: !this.state.pickRoom })} className="w-100">
                                <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                    <span className="align-self-center font-12">{selectedRoom.GivenName} ({selectedRoom.TOTAL})</span>
                                    <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                                </DropdownToggle>
                                <DropdownMenu className="w-100" style={{ maxHeight: 260, overflowY: 'auto' }}>
                                    {rooms.map((c, i) => (
                                        <DropdownItem key={i} onClick={() => {
                                            const { filters } = this.state;
                                            filters.IdRoom = c.IdRoom;
                                            this.setState({ filters, pickRoom: false });
                                        }}>{c.GivenName} ({c.TOTAL})</DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                )}

                {/* Floor */}
                {floors.length > 0 && (
                    <div style={{ minWidth: 150 }}>
                        <label className="white poppins font-11 d-block mb-1">Piso</label>
                        <div className="black-input d-flex">
                            <Dropdown isOpen={this.state.pickFloor} toggle={() => this.setState({ pickFloor: !this.state.pickFloor })} className="w-100">
                                <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                    <span className="align-self-center font-12">{selectedFloor ? selectedFloor.Label : 'Todos'}</span>
                                    <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                                </DropdownToggle>
                                <DropdownMenu className="w-100">
                                    <DropdownItem onClick={() => { const { filters } = this.state; filters.IdFloor = null; this.setState({ filters, pickFloor: false }); }}>Todos</DropdownItem>
                                    {floors.map((f, i) => (
                                        <DropdownItem key={i} onClick={() => {
                                            const { filters } = this.state;
                                            filters.IdFloor = f.IdFloor;
                                            this.setState({ filters, pickFloor: false });
                                        }}>{f.Label}</DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                )}

                {/* Booking status */}
                <div style={{ minWidth: 160 }}>
                    <label className="white poppins font-11 d-block mb-1">Estado</label>
                    <div className="black-input d-flex">
                        <Dropdown isOpen={this.state.pickStatus} toggle={() => this.setState({ pickStatus: !this.state.pickStatus })} className="w-100">
                            <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                <span className="align-self-center font-12">{selectedStatus ? selectedStatus.name : 'Todos'}</span>
                                <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                            </DropdownToggle>
                            <DropdownMenu className="w-100">
                                <DropdownItem onClick={() => { const { filters } = this.state; filters.IdStatus = null; this.setState({ filters, pickStatus: false }); }}>Todos</DropdownItem>
                                {config.booking_status.map((s, i) => (
                                    <DropdownItem key={i} onClick={() => {
                                        const { filters } = this.state;
                                        filters.IdStatus = s.id;
                                        this.setState({ filters, pickStatus: false });
                                    }}>{s.name}</DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>

                {/* Search */}
                <div style={{ minWidth: 200, flex: 1 }}>
                    <label className="white poppins font-11 d-block mb-1">Buscar</label>
                    <div className="bg-gray-2 black-input d-flex">
                        <i className="fas fa-search font-14 white align-self-center ps-3" />
                        <input className="w-100 p-3 white font-12" type="text" placeholder="Nombre, PNR, ID..."
                            onChange={e => this.setState({ search: e.target.value })} />
                    </div>
                </div>

                {/* Actions */}
                <div className="d-flex align-items-flex-end" style={{ gap: 6, alignSelf: 'flex-end' }}>
                    <button onClick={this.onFetch} className="btn btn-blue white d-flex align-items-center px-3" style={{ height: 46 }}>
                        <i className="fas fa-search font-14 me-2" />
                        <span className="poppins font-12">Buscar</span>
                    </button>
                    <ReactHTMLTableToExcel
                        id="occ-xls"
                        className="btn btn-link white bordered d-flex align-items-center px-3"
                        style={{ height: 46 }}
                        table="occ-table-xls"
                        filename="Ocupacion"
                        sheet="Ocupacion"
                        buttonText={<><i className="fas fa-file-excel font-14 me-2" /><span className="poppins font-12">Exportar</span></>}
                    />
                </div>
            </Animated>
        );
    }

    renderTable = () => {
        const filtered = this.getFiltered();

        return (
            <table className="table font-10" id="occ-table-xls" style={{ minWidth: 900 }}>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Loc</th>
                        <th>Estado</th>
                        <th>Tipo</th>
                        <th>Nombre(s)</th>
                        <th>Apellido(s)</th>
                        <th>ID / Pasaporte</th>
                        <th>Entrada</th>
                        <th>Hora</th>
                        <th>Salida</th>
                        <th>Noches</th>
                        <th>Saldo</th>
                        <th>F. Pago</th>
                        <th>Empresa</th>
                    </tr>
                </thead>
                <tbody>
                    {filtered.length === 0 && (
                        <tr>
                            <td colSpan={14} className="text-center gray poppins py-4">No hay habitaciones ocupadas con los filtros seleccionados.</td>
                        </tr>
                    )}
                    {filtered.map((r, index) => {
                        const main_guest = _.find(r.BOOK.Guests, g => !g.IsCompanion) || r.BOOK.Guests?.[0] || {};
                        const bs = _.find(config.booking_status, s => s.id === parseInt(r.BOOK.IdStatus, 10));
                        const nights = Math.abs(moment(r.BOOK.CheckOut).diff(moment(r.BOOK.CheckIn), 'days'));
                        const balance = r.BOOK.Accounting && r.BOOK.Accounting.length ? _.last(r.BOOK.Accounting).Balance : '-';
                        return (
                            <tr key={index}>
                                <td>{r.title}</td>
                                <td>{padWithZeros(r.BOOK.PNR)}</td>
                                <td>
                                    {bs && (
                                        <span className={`badge ${bs.color_class}`} style={{ borderRadius: 4, fontSize: '0.75em', padding: '2px 6px' }}>
                                            {bs.name}
                                        </span>
                                    )}
                                </td>
                                <td>{r.name}</td>
                                <td>{main_guest.FirstName}</td>
                                <td>{main_guest.LastName}</td>
                                <td>{main_guest.IdOrPassport}</td>
                                <td>{moment(r.BOOK.CheckIn).format('DD/MM/YYYY')}</td>
                                <td>{moment(r.BOOK.CheckIn).format('HH:mm')}</td>
                                <td>{moment(r.BOOK.CheckOut).format('DD/MM/YYYY')}</td>
                                <td>{nights}</td>
                                <td>{balance}</td>
                                <td>-</td>
                                <td>{main_guest.Coorp}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    renderCommon = () => {
        const { params } = this.props;
        const filtered = this.getFiltered();

        return (
            <div>
                {this.renderHeader()}
                <ReportTabs active="occupation" id={params.id} />

                {/* Outer container: flex column, NO overflow (so dropdowns aren't clipped) */}
                <div style={{ position: 'absolute', top: '11em', bottom: 0, left: 100, right: 0, display: 'flex', flexDirection: 'column' }} className="bg-gray-dark">

                    {/* Top zone: KPIs + filters — no overflow here so dropdowns show freely */}
                    <div className="px-3 pt-3" style={{ flexShrink: 0, position: 'relative', zIndex: 200 }}>
                        {this.renderKpis()}
                        {this.renderFilters()}
                    </div>

                    {/* Bottom zone: only this scrolls */}
                    <div style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }} className="px-3 pb-3">
                        {this.state.bootstrapped && (
                            <Animated animationIn="fadeInUp" animationInDuration={200}>
                                <div className="bg-gray-2 p-3 mt-2" style={{ borderRadius: 6, width: '100%' }}>
                                    <div className="d-flex align-items-center mb-2">
                                        <span className="white poppins font-12 toBold">{filtered.length} habitaciones</span>
                                        <span className="gray font-10 poppins ms-2">
                                            {moment(this.state.filters.CheckIn).format('DD/MM/YYYY')} — {this.state.filters.CheckOut ? moment(this.state.filters.CheckOut).format('DD/MM/YYYY') : ''}
                                        </span>
                                    </div>
                                    {this.renderTable()}
                                </div>
                            </Animated>
                        )}
                        {!this.state.bootstrapped && (
                            <div className="d-flex justify-content-center mt-5">
                                <span className="gray poppins font-14">Selecciona un rango de fechas y haz clic en Buscar.</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>
                    {this.state.microTransac && <LineLoader />}

                    <div className="w3-container w3-hide-small" style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>

                    <Menu {...this.state} {...this.props} />
                </section>
            </Layout>
        );
    }
}

export default Occupation;
